export default [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/modules/dashboard/pages/Entry.vue'),
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'Gives you a clear snapshot of your Etsy shop: track sales and rankings, discover trending keywords, and monitor competitors—all in one place.',
        },
        { page_slug: 'dashboard' },
      ],
      title: 'eRank — Dashboard',
      requiresAuth: true,
    },
  },
];
